<template>
  <div class="home">
    <!-- HEADER NEU -->
    <header
      class="home__header d-flex justify-content-center align-items-center"
    >
      <mdb-container class="header__content">
        <mdb-row>
          <mdb-col class="d-flex justify-content-end mt-md-5 mt-xs-0">
            <h1 class="header__heading">test studio finder</h1>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col class="header__content bg-white rounded z-depth-1 p-3">
            <mdb-row>
              <mdb-col>
                <h2 class="header__sub-heading">
                  Find the optimal test studio for your project
                </h2>
              </mdb-col>
            </mdb-row>

            <mdb-row>
              <mdb-col lg="4">
                <mdb-select
                  @getValue="testTypeSelected"
                  class="isi-select"
                  v-model="testTypesMdb"
                  label="What type of test do you plan?"
                  :visibleOptions="parseInt(10)"
                  outline
                />
              </mdb-col>

              <mdb-col lg="4">
                <mdb-tooltip
                  material
                  :delayOnMouseOut="300"
                  trigger="hover"
                  :options="{ placement: 'top' }"
                >
                  <span slot="tip">Multiple selections possible</span>
                  <mdb-select
                    class="isi-select isi-select-locations"
                    v-model="countriesMdb"
                    label="Where do you want to test?"
                    multiple
                    :visibleOptions="parseInt(10)"
                    outline
                    slot="reference"
                  />
                </mdb-tooltip>
                <span
                  @click="openFurtherLocationsModal"
                  class="link link-isi-sm"
                  >Further countries</span
                >
              </mdb-col>
              <mdb-col
                lg="4"
                class="
                  d-flex
                  align-items-start
                  justify-content-center justify-content-lg-start
                "
              >
                <mdb-btn @click="sendSearch" class="btn" color="isi"
                  >SEARCH</mdb-btn
                >
              </mdb-col>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </header>
    <!-- ./ HEADER NEU ENDE -->

    <!-- SECTION 1 NEU-->
    <section class="section mt-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">
              What can you do with the isi Test Studio Finder?
            </h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading text-center">3 simple steps</h3>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center">
          <mdb-col lg="8">
            <ul
              class="
                section__feature-list
                pl-0
                mt-4
                d-flex
                flex-column flex-lg-row
                justify-content-between
              "
            >
              <li
                class="section__feature-list-item mb-5 mb-lg-0"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <!--   <mdb-icon id="userlock-icon" icon="user-lock"  style="font-size:2.4rem; color:red;"/> -->
                <!--   <i class="fab fa-accusoft"  style="font-size:2.4rem; color:red;"></i> -->
                <i class="fas fa-search-location" style="font-size: 3rem"></i>

                <span class="section__feature-list-item-heading"
                  >Find fieldwork locations</span
                >
                <!--     <p class="section__feature-list-item-content" style="text-align:justify;">
                 Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsam ab quo dolore.
                </p> -->
              </li>
              <li
                class="section__feature-list-item mb-5 mb-lg-0"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <i class="fas fa-cogs" style="font-size: 3rem"></i>
                <span class="section__feature-list-item-heading"
                  >Generate your request</span
                >
                <!--  <p class="section__feature-list-item-content" style="text-align:justify;">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi suscipit unde voluptatibus quas.   
                </p> -->
              </li>
              <li
                class="section__feature-list-item mb-5 mb-lg-0"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <i class="far fa-paper-plane" style="font-size: 3rem"></i>
                <span class="section__feature-list-item-heading"
                  >Receive your proposal</span
                >
                <!--   <p class="section__feature-list-item-content" style="text-align:end;">
               Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aut, voluptatum?  
                </p> -->
              </li>
            </ul>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION 1 NEU-->
    <hr />
    <!-- SECTION 1 NEU-->
    <section class="section mt-5 mb-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">Your Benefits</h2>
          </mdb-col>
          <div class="w-100"></div>
        </mdb-row>

        <mdb-row class="justify-content-center">
          <mdb-col lg="8">
            <ul class="section__feature-list pl-0 mt-4">
              <li class="section__feature-list-item">
                <span class="section__feature-list-item-heading"
                  >Fast and convenient</span
                >
                <p class="section__feature-list-item-content">
                  Your one-stop gateway – isi is your direct contact and your
                  only contract partner for booking
                  <span class="d-xl-block"></span>
                  the test studios: 1 request, 1 supplier in your system, 1
                  contract, 1 invoice.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading"
                  >Quality assurance</span
                >
                <p class="section__feature-list-item-content">
                  Handpicked partners, certified with our isi QualityLabels. We
                  find the ‘local jewels’ and make
                  <span class="d-xl-block"></span>them available for your
                  project.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading"
                  >Transparent</span
                >
                <p class="section__feature-list-item-content">
                  Check floor plans and photos. Download detailed studio
                  information.
                  <span class="d-xl-block"></span> Experience virtual tours.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading">Flexible</span>
                <p class="section__feature-list-item-content">
                  Book what you need – from field-only studies over additional
                  field support to full-service project.
                </p>
              </li>
            </ul>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <router-link to="/about" class="btn btn-lg btn-light-green mt-3"
              >Learn More</router-link
            >
            <!--   <a
              class="section__learn-more-link btn btn-lg btn-light-green mt-3"
              href="/about"
              >Learn more</a
            > -->
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION 1 NEU-->
    <!-- SECTION 2 NEU-->
    <!--  <section class="section my-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">The isi QualityLabels</h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading section__quote text-center">
              "We certify our partners according to the high isi standards."
            </h3>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="8">
            <mdb-row>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-1-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-2-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-3-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-4-400-compressed.png"
                />
              </mdb-col>
            </mdb-row>
          </mdb-col>
        </mdb-row>
        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="8">
            <p class="section__content">
              The isi QualityLabels are exclusively awarded to selected isi
              fieldwork partner facilities, after the verification of required
              quality control measures. At a glance, you see which test studios
              are
              <span class="d-xl-block"></span>optimal for your project.
            </p>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <a
              class="section__learn-more-link btn btn-lg btn-light-green mt-3"
              href="/about/#isi-quality-labels"
              >Learn more</a
            >
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section> -->
    <!-- ./SECTION 2 NEU-->

    <app-footer />
  </div>
</template>
<script>
import AppFooter from "../components/Footer.vue";

export default {
  components: { AppFooter },
  name: "Home",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Home",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
  created() {
    if (this.$store.state.dataLoaded) {
      this.setupForm();
      this.handleQueryParams();
    } else {
      this.$watch("$store.state.dataLoaded", (newVal) => {
        if (newVal) {
          this.setupForm();
          this.handleQueryParams();
        }
      });
    }
  },
  data() {
    return {
      testTypesMdb: [],
      countriesMdb: [],
    };
  },
  computed: {
    testTypes() {
      return this.$store.state.testTypes;
    },
    countries() {
      return this.$store.state.countries;
    },
    continents() {
      return this.$store.state.continents;
    },
  },
  methods: {
    handleQueryParams() {
      if (
        this.$route.query.pw_reset &&
        this.$route.query.m &&
        this.$route.query.vc
      ) {
        this.$store.commit("setCurrentModal", {
          type: "resetPasswordModal",
          options: {
            email: this.$route.query.m,
            validation_code: this.$route.query.vc,
          },
        });
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else if (
        this.$route.query.verify_account &&
        this.$route.query.m &&
        this.$route.query.vc
      ) {
        this.activateAccount(this.$route.query.m, this.$route.query.vc);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    },
    testTypeSelected(testType) {
      for (let el of this.countriesMdb) {
        if (
          !el.optgroup &&
          !this.countries
            .find((x) => x.id == el.value)
            .availableTestTypes.includes(testType)
        ) {
          el.selected = false;
          el.disabled = true;
        } else {
          el.disabled = false;
        }
      }
      this.countriesMdb.sort();
    },
    setupForm() {
      let testType = this.$store.state.searchParams.testType;

      for (let el of this.$store.state.testTypes) {
        let selected = testType == el.id;
        this.testTypesMdb.push({
          text: el.displayName,
          value: el.id,
          selected,
        });
      }
      // set countriesMdb from countries and searchParams
      let out = [];

      for (let continent of this.continents.sort((a, b) => {
        if (a.displayName > b.displayName) return 1;
        if (a.displayName < b.displayName) return -1;
        return 0;
      })) {
        out.push({
          text: continent.displayName,
          value: null,
          disabled: true,
          optgroup: true,
        });

        for (let country of this.countries
          .filter((el) => el.continentData.id == continent.id)
          .sort((a, b) => {
            if (a.displayName > b.displayName) return 1;
            if (a.displayName < b.displayName) return -1;
            return 0;
          })) {
          let disabled = !country.availableTestTypes.includes(testType);
          let selected =
            this.$store.state.searchParams.countries.includes(country.id) &&
            !disabled;

          out.push({
            text: country.displayName,
            value: country.id,
            disabled,
            selected,
          });
        }
      }

      this.countriesMdb = out;
    },
    sendSearch() {
      let testType = this.testTypesMdb.find((x) => x.selected).value;
      let countries = this.countriesMdb
        .filter((x) => x.selected)
        .map((x) => x.value);
      this.$store.commit("setSearchParams", {
        testType: testType,
        countries: countries,
        features: [],
      });
      let testTypeLabel = this.$store.state.testTypes
        .find((x) => x.id == testType)
        .displayName.toLowerCase()
        .replace(/[\s-]/g, "_");
      window.gtag("event", "perform_search_landing_page", {
        event_category: "search_" + testTypeLabel,
        event_label: countries.length ? countries.join(",") : "none",
      });
      this.$router.push({ name: "Search" });
    },
    openFurtherLocationsModal() {
      this.$store.commit("setCurrentModal", {
        type: "FurtherLocationsModal",
        options: {
          testTypesMdb: JSON.parse(JSON.stringify(this.testTypesMdb)),
        },
      });
    },
    activateAccount(email, validationCode) {
      this.$http({
        method: "post",
        url: "/api/UserAction/ActivateAccount",
        data: {
          email,
          validationCode,
        },
      })
        .then(() => {
          this.$store.commit("setCurrentModal", {
            type: "GeneralInfoModal",
            options: {
              title: "Email address verified",
              content:
                "Our administrators will check your account and send an email when it is activated.",
            },
          });
        })
        .catch((err) => {
          let msg =
            err.response.data ??
            "We could not verify your account. Please contact us.";
          this.$store.commit("setCurrentModal", {
            type: "GeneralInfoModal",
            options: {
              title: "Error",
              content: msg,
            },
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "~@/styles/parts/_section.scss";
@import "~@/styles/views/_home.scss";
</style>


    

  